import { render, staticRenderFns } from "./activityCategory.vue?vue&type=template&id=3a40745a&scoped=true"
import script from "./activityCategory.vue?vue&type=script&lang=js"
export * from "./activityCategory.vue?vue&type=script&lang=js"
import style0 from "./activityCategory.vue?vue&type=style&index=0&id=3a40745a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a40745a",
  null
  
)

export default component.exports